/**
 * Concaténation de classes CSS, en ignorant les valeurs absentes.
 *
 * ```ts
 * cx(styles.carte, actif && styles.actif, className)
 * ```
 */
export function cx(
  ...parts: Array<string | false | null | undefined>
): string {
  return parts.filter(Boolean).join(" ");
}
